var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M3.15 0.734375H22.05C23.7727 0.734375 25.2 2.16172 25.2 3.88438V18.0594C25.2 19.8313 23.7727 21.2094 22.05 21.2094H15.2086L9.10547 25.7867C8.85938 25.9836 8.56406 25.9836 8.26875 25.8852C8.02266 25.7375 7.875 25.4914 7.875 25.1469V21.2094H3.15C1.37813 21.2094 0 19.8313 0 18.0594V3.88438C0 2.16172 1.37813 0.734375 3.15 0.734375Z",
    fill: "#2690FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.406a6fb96614ddcb16f4857d3282ce7a.svg";
export { ForwardRef as ReactComponent };